import { memo, useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import { convertBitsToBytes } from "../../../../../utils/easyMaps/convertToBytes";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import L from "leaflet";
import * as ReactDOMServer from "react-dom/server";
import { useOutletContext } from "react-router-dom";
import extractColorFromScale from "../../../../../utils/easyMaps/extractColorFromScale";

export const PolylineCustom = memo(
  (
    {
      configLine = null,
      host = "",
      data = null,
      positions,
      animation = "desativada",
      onClick = () => {},
      dbClick = () => {},
      percent = null,
      isDown = false,
      variant = "trafego",
      configLocal,
      disable = false,
      darkMode = false,
    },
    key
  ) => {
    const { config } = useOutletContext();
    const theme = useTheme();

    const [cor, setCor] = useState(null);
    const styles = {
      fontPopup: {
        margin: "0px",
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.color.textEasyMaps,
      },
      colorTextLayer: {
        color: theme.palette.text.primary,
        fontWeight: 600,
      },
      titlePopup: {
        margin: "0px",
        fontSize: "12px",
        fontWeight: 500,
        color: theme.palette.color.textEasyMaps,
        width: "100%",
        textAlign: "center",

        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 2, // Limite de 2 linhas
        WebkitBoxOrient: "vertical",
      },
      boxInfo: {
        display: "flex",
        flexDirection: "row",
        gap: "3px",
      },
      stackPopup: {
        width: "200px",
      },
    };
    let animationOp = {
      pontilhada: "1, 10",
      tracejada: "8, 13",
      desativada: null,
    };
    const map = useMap();

    const Content = () => {
      if (variant == "trafego") {
        const outPutTrafficData = convertBitsToBytes(data?.trafego?.tx);
        const inPutTrafficData = convertBitsToBytes(data?.trafego?.rx);

        return (
          <Stack key={key} style={styles.stackPopup}>
            <Typography style={styles.titlePopup}>{host}</Typography>
            <Typography
              style={{ ...styles.titlePopup, ...styles.colorTextLayer }}
            >
              {"[ " + data?.interface + " ]"}
            </Typography>
            <br />
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                TX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {outPutTrafficData.valor}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  {outPutTrafficData.unidade}
                </Typography>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                RX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {inPutTrafficData.valor}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  {inPutTrafficData.unidade}
                </Typography>
              </Box>
            </Box>
          </Stack>
        );
      } else if (variant == "potencia") {
        return (
          <Stack key={key} style={styles.stackPopup}>
            <Typography style={styles.titlePopup}>{host}</Typography>
            <Typography
              style={{ ...styles.titlePopup, ...styles.colorTextLayer }}
            >
              {"[ " + data?.interface + " ]"}
            </Typography>
            <br />
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                TX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {data?.potencia?.tx}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  dBm
                </Typography>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDiretion: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
              >
                RX:
              </Typography>
              <Box style={{ ...styles.boxInfo }}>
                <Typography style={{ ...styles.fontPopup }}>
                  {data?.potencia?.rx}
                </Typography>
                <Typography
                  style={{ ...styles.fontPopup, ...styles.colorTextLayer }}
                >
                  dBm
                </Typography>
              </Box>
            </Box>
          </Stack>
        );
      } else return null;
    };

    //var popup = L.popup();
    var popup = L.tooltip([0, 0], {
      permanent: false,
      direction: "top",
      offset: [0, -5],
      opacity: 0.9,
    });

    useEffect(() => {
      const color = extractColorFromScale({
        variant,
        percent,
        data,
        config,
        configLine,
        theme,
      });
      setCor(color.cor);
    }, [percent, data, config, variant, theme]);

    useEffect(() => {
      // Criação das linhas principais
      const line = L.polyline(positions, {
        // a linha tende a não renderizar na animção, para poupar reprocesso
        color: disable ? "transparent" : cor,
        weight: 3,
        dashArray: animationOp[animation],
        //renderer: L.svg(),
      }).addTo(map);

      const lineBase = L.polyline(positions, {
        color: "transparent",
        weight: 5,
        //renderer: L.svg(),
      }).addTo(map);

      // Configuração do popup

      popup.setContent(ReactDOMServer.renderToString(<Content />));

      // Event listeners
      lineBase.on("click", onClick);
      lineBase.on("dblclick", dbClick);
      lineBase.on("mouseover mousemove", (e) => {
        popup.setLatLng(e.latlng).openOn(map);
      });
      lineBase.on("mouseout mouseleave", () => {
        map.removeLayer(popup);
      });

      // Animação
      let offset = 0;
      let currentColors = cor;
      let lastChangeTime = 0; // Marca de tempo para mudanças de cor
      let animationFrameId; // Identificador da animação

      const animateDown = (timestamp) => {
        if (timestamp - lastChangeTime > 400) {
          currentColors =
            currentColors !== theme.palette.enlaces.p90.main
              ? theme.palette.enlaces.p90.main
              : theme.palette.enlaces.offline.main;
          lastChangeTime = timestamp;
        }
        line.setStyle({ color: currentColors });
        animationFrameId = requestAnimationFrame(animateDown);
      };

      const animate = (step) => {
        offset -= step;
        line.setStyle({ dashOffset: offset });
        animationFrameId = requestAnimationFrame(() => animate(step));
      };

      // Controle da animação
      if (data) {
        if (isDown) {
          animationFrameId = requestAnimationFrame(animateDown);
        } else if (
          animationOp[animation] !== null &&
          configLocal?.animacao?.linha !== false
        ) {
          const isTrafficInvalid =
            variant === "trafego" &&
            ["-", 0].includes(data?.trafego?.tx) &&
            ["-", 0].includes(data?.trafego?.rx);
          const isPowerInvalid =
            variant === "potencia" &&
            ["-", -40].includes(data?.potencia?.tx) &&
            ["-", -40].includes(data?.potencia?.rx);
          if (isTrafficInvalid || isPowerInvalid) {
            animationFrameId = requestAnimationFrame(() => animate(0));
          } else {
            animationFrameId = requestAnimationFrame(() => animate(0.5));
          }
        }
      }

      // Cleanup
      return () => {
        // Cancela animações

        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
        map.removeLayer(lineBase);
        map.removeLayer(line);
        map.removeLayer(popup);

        // Remove listeners
        lineBase.off("click", onClick);
        lineBase.off("dblclick", dbClick);
        lineBase.off("mouseover mousemove");
        lineBase.off("mouseout mouseleave");
      };
    }, [
      key,
      map,
      positions,
      animation,
      configLocal,
      cor,
      configLocal?.animacao?.linha,
      disable,
      variant,
    ]);

    return null;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.darkMode === nextProps.darkMode &&
      prevProps.host === nextProps.host &&
      prevProps.animation === nextProps.animation &&
      prevProps.percent === nextProps.percent &&
      prevProps.isDown === nextProps.isDown &&
      prevProps.disable === nextProps.disable &&
      prevProps.variant === nextProps.variant &&
      prevProps.configLocal?.animacao?.linha ===
        nextProps?.configLocal?.animacao?.linha &&
      prevProps?.data?.potencia?.thresholds?.hightTx ===
        nextProps?.data?.potencia?.thresholds?.hightTx &&
      prevProps?.data?.potencia?.thresholds?.lowTx ===
        nextProps?.data?.potencia?.thresholds?.lowTx &&
      prevProps?.data?.potencia?.thresholds?.hightRx ===
        nextProps?.data?.potencia?.thresholds?.hightRx &&
      prevProps?.data?.potencia?.thresholds?.lowRx ===
        nextProps?.data?.potencia?.thresholds?.lowRx
    );
  }
);

export function PolylineSimple(
  { positions = [], dbClick = () => {}, color = null, onClick = () => {} },
  key
) {
  const theme = useTheme();
  const map = useMap();

  useEffect(() => {
    const line = L.polyline(positions, {
      color: color ? color : theme.palette.enlaces.offline.main,
      weight: 3,
    }).addTo(map);
    line.on("dblclick", dbClick);
    line.on("click", onClick);

    return () => {
      map.removeLayer(line);
      line.off("click", onClick);
      line.off("dblclick", dbClick);
    };
  }, [positions, theme, dbClick, key]);

  return null;
}
